<template>
	<div class="intro">
		<PublicIntro v-if="ready" :clients="clients" />
	</div>
</template>

<script>
import axios from 'axios'
import PublicIntro from '@/components/Intro/PublicIntro'

export default {
	name: 'Intro',
	components: {PublicIntro},

	data() {
		return {
			clients: []
		}
	},

	computed: {
		ready() {
			//return ! this.$store.state.loading && this.$store.state.mapsApi
			return ! this.$store.state.loading
		}
	},

	mounted() {
		this.$store.state.loading = true

		// Load clients
    	axios.get(this.$apiUrl + '/api/intro/clients').then(res => {
    		this.clients = res.data.clients
    		this.$store.state.translations = res.data.translations

    		setTimeout(() => this.$store.state.loading = false, 500)
    	})
	}
}
</script>
